module.exports = __webpack_public_path__ + "img/12ne.b5b2e746.svg";